// extracted by mini-css-extract-plugin
export default {"confetti":"confetti__Njc4Y","explode":"explode__NjY1M","fade":"fade__ZjQ1N"};